import { render, staticRenderFns } from "./RecentlyMarkedWidget.vue?vue&type=template&id=3d69f4e8"
import script from "./RecentlyMarkedWidget.vue?vue&type=script&lang=js"
export * from "./RecentlyMarkedWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports